import { BoxProps, Spacer, TextProps } from '@jfs/ui-new'
import { ButtonNew as Button } from '../../components/AdminButton'
import { useEffect, useState } from 'react'
import { useWindowDimensions } from 'react-native'
import { Container } from '../../components/Container'
import { DropdownOptimised } from '../../components/DropdownNew'
import { ModalAlertView } from '../../components/ModalAlertView'
import { NewTable } from '../../components/NewTable'
import { useLazyApiData, useStores } from '../../data/store'
import { isAccessible } from '../../utils'
import { AddNewDeviceModel } from './AddNewDeviceModel'

const ViewAndAddDeviceVariant = () => {
  const { deviceVariantList, getDevicesListAsync, deleteDeviceVariantAsync, addNewDeviceVariantAsync, accessConfig } =
    useStores((store) => ({
      deviceVariantList: store.onboarding.deviceVariantList,
      getDevicesListAsync: store.onboarding.getDevicesListAsync,
      deleteDeviceVariantAsync: store.onboarding.deleteDeviceVariantAsync,
      addNewDeviceVariantAsync: store.onboarding.addNewDeviceVariantAsync,
      accessConfig: store.user.getAccessConfig(['merchant_config', 'device_variant']),
    }))
  const [showConfirmAlert, setShowConfirmAlert] = useState(false)
  const [clickedId, setClickedId] = useState('')
  const [showAddNewDeviceModel, setShowAddNewDeviceModel] = useState(false)
  const [deviceType, setDeviceType] = useState('VOICEBOX')

  const [lazyGetDeviceListAsync, getDeviceListAsyncHandler] = useLazyApiData(getDevicesListAsync)
  const [lazyAddNewDeviceAsync, addNewDeviceAsyncHandler] = useLazyApiData(addNewDeviceVariantAsync)
  const { width }: any = useWindowDimensions()

  useEffect(() => {
    lazyGetDeviceListAsync(deviceType)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceType])

  useEffect(() => {
    if (addNewDeviceAsyncHandler.state === 'fulfilled') {
      setShowAddNewDeviceModel(false)
      lazyGetDeviceListAsync(deviceType)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addNewDeviceAsyncHandler.state])
  const headerTitles = isAccessible(accessConfig, 'delete')
    ? {
        id: 'Variant Id',
        name: 'Variant Name',
        type: 'Variant Type',
        status: 'STATUS',
        actionDownload: ' ',
      }
    : {
        id: 'Variant Id',
        name: 'Variant Name',
        type: 'Variant Type',
        status: 'STATUS',
      }

  return (
    <Container
      isLoading={getDeviceListAsyncHandler.state === 'pending'}
      errorMessage={getDeviceListAsyncHandler?.data?.message}
      onRetry={() => lazyGetDeviceListAsync('VOICEBOX')}>
      <Button
        onPress={() => setShowAddNewDeviceModel(true)}
        type={'primaryIcon'}
        width={180}
        height={40}
        icon="ADD"
        hide={!isAccessible(accessConfig, 'add')}
        title={'Add new Device'}
      />
      <Spacer size={20} />
      <DropdownOptimised
        placeHolder="Select Device Type"
        label="Select Device Type"
        value={deviceType}
        data={[
          { id: 'VOICEBOX', value: 'VOICEBOX' },
          { id: 'SQR', value: 'SQR' },
        ]}
        onChange={(type) => setDeviceType(type as string)}
      />
      <Spacer size={20} />
      <NewTable
        data={deviceVariantList}
        rowHeight={48}
        headerHeight={64}
        headerRowKeys={headerTitles}
        // onRowEditClicked={onItemChecked}
        freezeColumn={'selected'}
        onAction={(_, id) => {
          setShowConfirmAlert(true)
          setClickedId(id)
        }}
        tableWidth={width > 1200 ? width - 290 : width}
        onRowClick={() => {}}
      />
      <ModalAlertView
        message={'Are you sure you want to delete this  variant?'}
        show={showConfirmAlert}
        showHeader={false}
        isConfirmationCheckRequired={false}
        title={''}
        buttonTitle={'Delete'}
        cancelTitle={'Dismiss'}
        onDismiss={() => setShowConfirmAlert(false)}
        onPress={async () => {
          const resp = await deleteDeviceVariantAsync(clickedId).catch((ex) => {})
          lazyGetDeviceListAsync(deviceType)
          setShowConfirmAlert(false)
        }}
        onCancel={() => setShowConfirmAlert(false)}
        positiveButtonColor={'PRIMARY'}
        cancelButtonColor={'WHITE'}
        height={80}
        width={400}
      />
      <AddNewDeviceModel
        show={showAddNewDeviceModel}
        onDismiss={() => {
          setShowAddNewDeviceModel(false)
          if (addNewDeviceAsyncHandler.data) {
            addNewDeviceAsyncHandler.data.message = ''
          }
        }}
        onPress={(args: any) => {
          lazyAddNewDeviceAsync(args.variantName, args.variantType)
        }}
        errorMessage={addNewDeviceAsyncHandler.state === 'rejected' && addNewDeviceAsyncHandler?.data?.message}
        isLoading={addNewDeviceAsyncHandler.state === 'pending'}
      />
    </Container>
  )
}

export default ViewAndAddDeviceVariant

const styles = {
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    margin: 20,
  } as BoxProps,
  buttonText: {
    color: 'WHITE',
    fontSize: 14,
    fontWeight: 'FONT_WEIGHT_BOLD',
  } as TextProps,
}
